import { AttachFileOutlined, ChatOutlined, Close, DescriptionOutlined, Cancel, CloudDone, CloudUpload, UploadFile, CloudDownloadOutlined } from '@mui/icons-material';
import { Box, Drawer, Grid, IconButton, Typography, CircularProgress, Button, Dialog, DialogActions, DialogContent, capitalize, Divider, LinearProgress, ListSubheader } from '@mui/material';
import { DataGrid, GridFooter } from '@mui/x-data-grid';
import React, { useEffect, useState, useCallback } from 'react';
import { CPDReOpenCase, ReCategoriseCases } from '../redux/api/workflows';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { Transition } from '../pages/internal/ReturnSubmission';
import { useDropzone } from 'react-dropzone';
import { Form, Formik } from 'formik';
import TextInput from './common/TextInput';
import Filters from './Filters';
import SelectInput from './common/SelectInput';
import { getAllCaseDetails, getCaseUpdateHistoryByCaseId } from '../redux/api/cases';
import { getWorkflowHistoryAndTasksByWorkflowId } from '../redux/api/workflows';
import { attachDocumentsToCase, CPDCloseCase, CPDResolveCase, assignBreachedCasesToROs, CPDInternalCaseEscalation, returnCasesToFIsWithTask } from '../redux/api/workflows';
import { getPrivilegeStatus } from '../util';
import { updatePageSize } from '../redux/actions/userActions';
import { bindActionCreators } from 'redux';
import CaseDetails from './CaseDetails';
import { useMediaQuery } from 'react-responsive';
import { getAllInstitutions, getInstitutionTypes } from '../redux/api/institution';
import { getAllSubcategories, getAllCategories } from '../redux/api/userMgt';
import DocumentInput from './common/DocumentInput';

export const DrawerOptions = ['Case Details', 'Conversations', 'Mails', 'Re-Submission History'];

const CaseTable = ({
    cases = [],
    customColumns = [],
    user,
    addActionColumn = false,
    showResolveCaseBtn = true,
    showDeEscalateCaseBtn = true,
    showCloseCaseBtn = true,
    showEscalateCaseBtn = true,
    showCustomFooter = true,
    selectable = true,
    showConversationBtn = true,
    showDetailsBtn = true,
    showAttachBtn = true,
    showAssignFooterBtn = false,
    showReOpenFooterBtn = false,
    showReAssignFooterBtn = false,
    initFunction,
    additionalActions,
    parentRoleUsers = [],
    childRoleUsers = [],
    showReportedInstitutions = false,
    showRecategorizeCaseBtn = false,
    relationshipOfficers = [],
    escalateCaseFunction,
    exportFunction = null,
    searchFunction = null,
    institutions = [],
    subCategories = [],
    paginationData,
    sendMessageBtn = false,
    useDefault = false,
    updatePageSize,
}) => {
    const [open, setOpen] = useState(false);
    const [processing, setProcessing] = useState(null);
    const [exporting, setExporting] = useState(false);
    const [userData, setUserData] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [caseDetails, setCaseDetails] = useState();
    const [selectedAction, setSelectedAction] = useState();
    const defMessage = { subject: '', message: '', attachment: '' };
    const [openDialog, setOpenDialog] = useState(null);
    const [uploadProcess, setUploadProcess] = useState(''); // uploading, failed, success
    const [fileToUpload, setFileToUpload] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [fetchingCaseDetails, setFetchingCaseDetails] = useState(false);
    const [actionsView, setActionsView] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    const [caseAction, setCaseAction] = useState(null);
    const [recordsToEscalate, setRecordsToEscalate] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [inst, setInst] = useState([]);
    const [messageModal, setMessageModal] = useState(false);
    const [pageSize, setPageSize] = useState(paginationData?.size || 50);
    const [caseDrawer, setCaseDrawer] = useState(0);
    const [caseCategoryList, setCaseCategoryList] = useState([]);
    const [subCategoriesInit, setSubCategoriesInit] = useState([]);
    const [subCategoriesList, setSubCategoriesList] = useState([]);
    const lg = useMediaQuery({ query: '(min-width: 1000px)' });
    const md = useMediaQuery({ query: '(min-width: 750px)' });

    const onDrop = useCallback((acceptedFiles) => {
        setFileToUpload(acceptedFiles[0]);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: false,
        accept: {
            'image/jpeg': ['.jpeg', '.png'],
            'application/pdf': ['.pdf'],
        },
    });

    const [records, setRecords] = useState(cases);

    const actionColumn = {
        field: 'id',
        headerName: 'Action',
        width: 120,
        sortable: false,
        renderCell: (params) => (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                }}
            >
                {additionalActions && additionalActions(params?.row)}

                {showDetailsBtn && (
                    <IconButton
                        size="small"
                        color="primary"
                        variant="outlined"
                        title="More Details"
                        onClick={() => {
                            fetchDetails(params?.row, 0);
                        }}
                    >
                        {fetchingCaseDetails == params?.row?.caseId && processing == 0 ? <CircularProgress size={12} color="inherit" /> : <DescriptionOutlined />}
                    </IconButton>
                )}

                {showConversationBtn && (
                    <IconButton
                        size="small"
                        color="secondary"
                        onClick={() => {
                            fetchDetails(params?.row, 1);
                        }}
                        variant="outlined"
                        title="View Conversations"
                    >
                        {processing == 1 && fetchingCaseDetails == params?.row?.caseId ? <CircularProgress size={12} color="inherit" /> : <ChatOutlined />}
                    </IconButton>
                )}
                {showAttachBtn && (
                    <IconButton size="small" color="info" variant="outlined" title="Attach Files" onClick={() => setOpenDialog(params?.row?.caseId)}>
                        <AttachFileOutlined />
                    </IconButton>
                )}
                {/* {
                        showPendingActionsBtn &&
                        <IconButton
                            size='small'
                            color="warning"
                            variant="outlined" title='Pending Actions'
                            onClick={() => { fetchDetails(params?.row?.caseId, 3)}}
                        >
                            <Badge badgeContent={params?.row?.workflowActionableCount || 0} color="warning">
                                <PendingActionsOutlined />
                            </Badge>
                        </IconButton>
                    } */}
            </div>
        ),
    };

    const columns = [
        actionColumn,
        // { field: 'workflowActionableCount', headerName: 'Pending Actions', description: 'Pending Actions', width: 180, renderCell: (params) => (params?.row?.workflowActionableCount > 0)  ? <Chip onClick={() => fetchConversations(params?.row, 2)} style={{ cursor: 'pointer' }} size='small' color='error' label={params?.row?.workflowActionableCount + ' Action' + ((params?.row?.workflowActionableCount > 1) ? 's':'')} /> : <></> },
        { field: 'caseId', headerName: 'Case ID', width: 250 },
        {
            field: 'trackingReferenceNumber',
            headerName: 'Tracking Reference No.',
            width: 250,
        },
        { field: 'branchName', headerName: 'Branch Name', width: 200 },
        {
            field: 'institutionCode',
            headerName: 'Institution',
            width: 220,
            valueGetter: (params) => inst?.find((r) => r?.institutionId == params?.row?.institutionId)?.name ?? params?.row?.institutionCode,
        },
        {
            field: 'consultant_name',
            headerName: 'Name of Consultant',
            width: 250,
            valueGetter: (params) => `${params?.row?.lastName} ${params?.row?.firstName}`,
        },
        { field: 'clientTypeName', headerName: 'Type of Client', width: 200 },
        {
            field: 'nameOfConsultant',
            headerName: 'Name of Complainant',
            width: 250,
        },
        {
            field: 'uniqueIdentificationNo',
            headerName: 'Unique Identification No.',
            width: 250,
        },
    ];

    const uploadFile = async () => {
        if (fileToUpload) {
            try {
                setUploadProcess('uploading');
                const formData = new FormData();
                formData.append('caseId', openDialog);
                formData.append('attachments[0][fileDescription]', fileToUpload?.name || '');
                formData.append('attachments[0][internalUseOnly]', true);
                formData.append('attachments[0][attachmentDocument]', fileToUpload);

                await attachDocumentsToCase(formData);
                setUploadProcess('success');
                setFileToUpload(null);
                // init();
            } catch (err) {
                enqueueSnackbar(err?.message || 'Failed to upload file', {
                    variant: 'error',
                });
                setUploadProcess('failed');
            }
        } else {
            enqueueSnackbar('Error: No File to upload', { variant: 'error' });
        }
    };

    const fetchDetails = async (caseData, key) => {
        try {
            setProcessing(key);
            setFetchingCaseDetails(caseData?.caseId);
            const res = await getAllCaseDetails(caseData?.caseId);
            let conversations = {};
            if (res?.resultObject?.workflow?.workflowId) {
                conversations = await getWorkflowHistoryAndTasksByWorkflowId(res?.resultObject?.workflow?.workflowId);
            }
            const caseHistory = await getCaseUpdateHistoryByCaseId(caseData?.caseId);
            setCaseDetails({
                ...caseData,
                ...res?.resultObject,
                caseWithReportedFIs: caseData?.caseWithReportedFIs || null,
                chats: conversations?.resultObject?.chatCommunications || [],
                publicMailConversation: conversations?.resultObject?.publicMailConversation?.emailResponseVM?.value || [],
                internalMailConversation: conversations?.resultObject?.internalMailConversation?.emailResponseVM?.value || [],
                caseHistory: caseHistory?.resultObject || [],
            });
            setOpenDrawer(true);
            if (key) setCaseDrawer(key);
            // setRecords(res?.resultObject?.data || []);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(null);
            setFetchingCaseDetails(null);
        }
    };

    const completeTask = async (values) => {
        try {
            setProcessing(true);
            // await addWorkflowCommunication({
            //     "workflowId": selectedAction?.workflowId,
            //     "caseId": selectedAction?.caseId,
            //     "username": userData?.username,
            //     "subject": values.subject,
            //     "message": values.message,
            //     "wFActionableCommId": selectedAction?.id, // confirm this
            //     "IsTaskCompleted": true
            // });
            // await fetchConversations(caseDetails)
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    // const fetchConversations = async (caseInfo, tab = 0) => {
    //     try {
    //         setFetching(true)
    //         const data = await getCaseCommunicationByCaseId(caseInfo.caseId);
    //         const { resultObject = [] } = await getActionableTasksByCaseId(caseInfo?.caseId);
    //         setCaseDetails({ ...caseInfo, actions: resultObject, messages: data?.resultObject || [] });
    //         setCaseConversationDrawer(tab)
    //         setOpen(true);
    //     }
    //     catch(err) {
    //         enqueueSnackbar(err?.message || 'An error occurred', { variant: 'error' })
    //     }
    //     finally {
    //         setFetching(false)
    //     }
    // }

    const handlePriorityChange = (value, index) => {
        let arr = [...recordsToEscalate];
        arr[index]['priority'] = value;
        setRecordsToEscalate(arr);
    };

    const init = async () => {
        await getAllInstitutions().then((res) => {
            setInst(res?.resultObject?.map((next) => ({ ...next, institutionId: String(next?.institutionId ?? '') })) ?? []);
        });

        await getAllCategories().then((res) => {
            setCaseCategoryList(res?.resultObject || []);
        });

        await getAllSubcategories().then((res) => {
            setSubCategoriesInit(res?.resultObject || []);
            setSubCategoriesList(res?.resultObject || []);
        });
    };

    const performAction = async (values, { resetForm }) => {
        try {
            const formData = new FormData();
            switch (caseAction) {
                case 'recategorise':
                    await ReCategoriseCases({
                        caseIds: selectionModel,
                        subcategoryCode: values?.subcategoryCode || '',
                    });
                    enqueueSnackbar(`Case(s) Recategorized Successfully`);
                    break;
                case 'close':
                    await CPDCloseCase({ caseIds: selectionModel });
                    enqueueSnackbar(`Case(s) Closed Successfully`);
                    break;
                case 'de-escalate':
                    await CPDCloseCase({ caseIds: selectionModel });
                    enqueueSnackbar(`Case(s) De-Escalated Successfully`);
                    break;
                case 'assign':
                    await assignBreachedCasesToROs({
                        caseIds: selectionModel,
                        roId: values?.toUserId,
                        subject: values?.subject || '',
                        message: values?.message || '',
                    });
                    enqueueSnackbar(`Case(s) Case Assigned Successfully`);
                    break;
                case 're-assign':
                    await assignBreachedCasesToROs({
                        caseIds: selectionModel,
                        roId: values?.toUserId,
                        subject: values?.subject || '',
                        message: values?.message || '',
                    });
                    enqueueSnackbar(`Case(s) Re-Assigned Successfully`);
                    break;
                case 're-open':
                    await CPDReOpenCase(selectionModel);
                    enqueueSnackbar(`Case(s) Re-Opened Successfully`);
                    break;
                case 'escalate':
                    if (escalateCaseFunction) {
                        const resp = await escalateCaseFunction(recordsToEscalate);

                        enqueueSnackbar(resp?.isSuccess ? `Case(s) Escalated Successfully` : resp?.message || `An error occurred`, { variant: resp?.isSuccess ? 'success' : 'error' });
                    } else {
                        selectionModel?.map((id, key) => formData.append(`CaseIds[${key}]`, id));
                        // formData.append('Subject', values?.subject || '')
                        formData.append('Message', values?.message || '');
                        formData.append('ToUserId', values?.toUserId || '');

                        await CPDInternalCaseEscalation(formData);
                        enqueueSnackbar(`Case(s) Escalated Successfully`);
                    }
                    break;
                case 'de-escalate':
                    selectionModel?.map((id, key) => formData.append(`CaseIds[${key}]`, id));
                    // formData.append('Subject', values?.subject || '')
                    formData.append('Message', values?.message || '');
                    formData.append('ToUserId', values?.toUserId || '');
                    await CPDInternalCaseEscalation(formData);
                    enqueueSnackbar(`Case(s) De-escalated Successfully`);
                    break;
                case 'resolve':
                    await CPDResolveCase({
                        caseIds: selectionModel,
                        subject: values?.subject || '',
                        message: values?.message || '',
                    });
                    enqueueSnackbar(`Case(s) Resolved Successfully`);
                    break;
                case 'returnToFi':
                    await returnCasesToFIsWithTask({
                        caseIds: selectionModel,
                        subject: values?.subject || '',
                        message: values?.message || '',
                    });
                    enqueueSnackbar(`Case(s) returned to FI Successfully`);
                    break;
                default:
                    break;
            }
            //     setEscalating(true)
            //     await escalateCases(recordsToEscalate);
            if (initFunction) initFunction();
            setRecordsToEscalate([]);
            setSelectionModel([]);
            setCaseAction(null);
            resetForm();
            //     setShowEscalationList(false)
        } catch (err) {
            enqueueSnackbar(err?.message || 'Error: Action Failed', {
                variant: 'error',
            });
        }
    };

    const exportData = async () => {
        try {
            setExporting(true);
            await exportFunction();
        } finally {
            setExporting(false);
        }
    };

    const CustomToolbar = () =>
        selectionModel?.length > 0 ? (
            <Grid container spacing={2} className="p-1 pl-1" alignItems="center">
                {showCustomFooter && (
                    <Grid item xs={12} md={6.5}>
                        <div className="d-flex">
                            {getPrivilegeStatus('AssignBreachedCasesToROs') && showAssignFooterBtn && (
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setCaseAction('assign');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Assign
                                </Button>
                            )}
                            {getPrivilegeStatus('CPDResolveCase') && showResolveCaseBtn && (
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setCaseAction('resolve');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Resolve
                                </Button>
                            )}
                            {getPrivilegeStatus('ReCategoriseCases') && showRecategorizeCaseBtn && (
                                <Button
                                    color="info"
                                    className="ml-1"
                                    onClick={() => {
                                        setCaseAction('recategorise');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Recategorise Case
                                </Button>
                            )}
                            {getPrivilegeStatus(['CPDEscalateCases', 'CPDInternalCaseEscalation']) && showEscalateCaseBtn && (
                                <Button
                                    onClick={() => {
                                        const recordsToEscalate =
                                            selectionModel?.map((caseId) => ({
                                                caseID: caseId,
                                                priority: 'HIGH',
                                            })) || [];
                                        setRecordsToEscalate(recordsToEscalate);
                                        setCaseAction('escalate');
                                    }}
                                    color="warning"
                                    className="ml-1"
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Escalate
                                </Button>
                            )}
                            {getPrivilegeStatus('CPDInternalCaseDeescalation') && showDeEscalateCaseBtn && (
                                <Button
                                    className="ml-1"
                                    color="secondary"
                                    onClick={() => {
                                        setCaseAction('de-escalate');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    De-escalate
                                </Button>
                            )}
                            {getPrivilegeStatus('CPDCloseCase') && showCloseCaseBtn && (
                                <Button
                                    className="ml-1"
                                    color="error"
                                    onClick={() => {
                                        setCaseAction('close');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Close
                                </Button>
                            )}
                            {getPrivilegeStatus('CPDReOpenCase') && showReOpenFooterBtn && (
                                <Button
                                    className="ml-1"
                                    color="primary"
                                    onClick={() => {
                                        setCaseAction('re-open');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Re-Open
                                </Button>
                            )}
                            {getPrivilegeStatus('AssignBreachedCasesToROs') && showReAssignFooterBtn && (
                                <Button
                                    className="ml-1"
                                    color="primary"
                                    onClick={() => {
                                        setCaseAction('re-assign');
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Re-Assign
                                </Button>
                            )}
                            {/* {
                            getPrivilegeStatus('ReturnCasesToFIsWithTask') && returnToFiBtn &&
                            <Button className='ml-1' color='info' 
                                onClick={() => {
                                    setCaseAction('returnToFi')
                                }} 
                                disabled={Boolean(selectionModel?.length === 0)} variant='contained'
                            >
                                Return to FI
                            </Button>
                        } */}
                            {sendMessageBtn && (
                                <Button
                                    className="ml-1"
                                    color="info"
                                    onClick={() => {
                                        setMessageModal(true);
                                    }}
                                    disabled={Boolean(selectionModel?.length === 0)}
                                    variant="contained"
                                >
                                    Return to FI with Message
                                </Button>
                            )}
                        </div>
                    </Grid>
                )}
                <Grid item xs={12} container md={5.5}>
                    <GridFooter />
                </Grid>
            </Grid>
        ) : (
            <GridFooter />
        );

    const getBtnColor = () => {
        switch (caseAction) {
            case 'escalate':
                return 'warning';
            case 'de-escalate':
                return 'secondary';
            case 'resolve':
                return 'primary';
            case 'close':
                return 'error';
            default:
                return 'primary';
        }
    };

    const sendMessage = async (values, { resetForm }) => {
        try {
            const formData = new FormData();

            formData.append('message', values.message);
            selectionModel?.forEach((id, key) => {
                formData.append(`caseIds[${key}]`, id);
            });
            formData.append('attachments[0][fileDescription]', values?.attachment?.name || '');
            formData.append('attachments[0][internalUseOnly]', true);
            formData.append('attachments[0][attachmentDocument]', values?.attachment);

            await returnCasesToFIsWithTask(formData);
            setMessageModal(false);
            setSelectionModel([]);
            resetForm();
            // await fetchConversations(caseDetails)
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        }
    };

    const updateRecords = async (start = 0, length = 50) => {
        try {
            setTableLoading(true);
            if ((start > (paginationData?.start || 0) || records?.length == 0) && records?.length <= start) {
                await initFunction(start, length);
            }
        } finally {
            setTableLoading(false);
        }
    };

    useEffect(() => {
        setRecords(cases);
    }, [cases]);

    useEffect(() => {
        setUserData(user.userData);
    }, [user]);

    useEffect(() => {
        setPageSize(paginationData?.size || pageSize);
    }, [paginationData]);

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            <Filters
                searchFields={[
                    { label: 'Tracking Reference', id: 'trackingReferenceNumber' },
                    {
                        label: 'Complaint Status',
                        id: 'statusOfComplaintName',
                        options: [{ value: 'ASSIGNED' }, { value: 'CLOSED' }, { value: 'NEW' }, { value: 'PENDING_INPUT' }, { value: 'REJECTED' }, { value: 'RESOLVED' }],
                        field: 'value',
                        fieldDisplay: 'value',
                        type: 'select',
                    },
                    {
                        label: 'Complaint Category',
                        id: 'category',
                        type: 'select',
                        field: 'categoryId',
                        fieldDisplay: 'name',
                        options: caseCategoryList,
                        customChange: (name, value) => {
                            setSubCategoriesInit(subCategoriesList.filter((next) => next?.categoryId == value));
                        },
                    },

                    { label: 'Complaint SubCategory', id: 'complaintCategoryCode', options: subCategoriesInit, field: 'code', fieldDisplay: 'name', type: 'select' },

                    { label: 'Account Number', id: 'accountNumber' },
                    { label: 'Institution', id: 'institutionId', options: inst, field: 'institutionId', fieldDisplay: 'name', type: 'select' },
                    { label: 'Institution Type', id: 'institutionTypeId', selectFunction: getInstitutionTypes, field: 'institutionTypeId', fieldDisplay: 'name', type: 'select' },

                    { label: 'SLA Breached', id: 'slaBreached', type: 'select', options: [{ value: 'true' }, { value: 'false' }], field: 'value', fieldDisplay: 'value' },
                    { label: 'Start Date Received', id: 'dateReceivedFrom', type: 'date' },
                    { label: 'End Date Received', id: 'dateReceivedTo', type: 'date' },

                    { label: 'Start Submission Date', id: 'submissionDateFrom', type: 'date' },
                    { label: 'End Submission Date', id: 'submissionDateTo', type: 'date' },
                ]}
                advancedSearchFields={false}
                showFilter
                useDefault={useDefault}
                searchFunction={searchFunction}
            />

            <Box mt={1}>
                <div className={`paper pt-1`} style={{ height: 550, width: '100%', textAlign: 'center' }}>
                    {exportFunction && records?.length > 0 && (
                        <div className="export-btn">
                            <Button onClick={exportData} variant="outlined" startIcon={<CloudDownloadOutlined />}>
                                {exporting ? <CircularProgress color="inherit" size={15} /> : 'Export'}
                            </Button>
                        </div>
                    )}
                    <DataGrid
                        className={selectable ? 'center-first-selection' : 'center-first-column'}
                        rows={records || []}
                        getRowId={(row) => row.caseId}
                        columns={[
                            {
                                field: 'sn',
                                headerName: 'S/N',
                                width: 80,
                                renderCell: (params) => <p style={{ margin: 'auto' }}>{params.api.getRowIndex(params?.row?.caseId) + 1}</p>,
                            },
                            ...(customColumns.length > 0 ? (addActionColumn ? [actionColumn, ...customColumns] : customColumns) : columns),
                        ]}
                        style={{ fontSize: '12px' }}
                        pageSize={user.paginationSize}
                        onPageSizeChange={(newPageSize) => updatePageSize(newPageSize)}
                        rowCount={paginationData?.total || records?.length || 0}
                        rowsPerPageOptions={[25, 50, 100]}
                        checkboxSelection={selectable}
                        disableSelectionOnClick
                        selectionModel={selectionModel}
                        onSelectionModelChange={(selectionModel) => {
                            setSelectionModel(selectionModel);
                        }}
                        components={{
                            Footer: CustomToolbar,
                            LoadingOverlay: LinearProgress,
                        }}
                        onPageChange={async (params) => {
                            await updateRecords(params * paginationData?.length);
                        }}
                        loading={tableLoading}
                    />
                </div>
            </Box>

            <Dialog
                open={Boolean(openDialog)}
                onClose={() => {
                    if (uploadProcess !== 'uploading') {
                        setOpenDialog(false);
                        setFileToUpload(null);
                    }
                }}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="lg"
                disableEscapeKeyDown
            >
                <DialogContent>
                    {Boolean(uploadProcess) ? (
                        <div className="dropzone" style={{ cursor: 'initial' }}>
                            {Boolean(uploadProcess === 'uploading') ? (
                                <CircularProgress style={{ fontSize: '50px' }} />
                            ) : Boolean(uploadProcess === 'success') ? (
                                <CloudDone color="primary" />
                            ) : (
                                <Cancel style={{ fontSize: '50px', color: 'brown' }} />
                            )}
                            {Boolean(uploadProcess === 'success') && <h3 className="text-success mb-0">File Uploaded Successfully</h3>}
                            {Boolean(uploadProcess === 'failed') && <h3 className="text-error mb-0">File Uploaded Failed</h3>}
                            <p className="mt-05 mb-05">{fileToUpload?.name}</p>
                            {/* <p className='m-0'>{parseFloat(fileToUpload?.size/1024).toFixed(2)} KB</p> */}
                            <p className="m-0">{fileToUpload ? parseFloat(fileToUpload?.size / 1024).toFixed(2) + 'KB' : ''}</p>
                        </div>
                    ) : (
                        <div {...getRootProps()}>
                            <input {...getInputProps()} multiple={false} accept="image/jpeg,image/gif,image/png,application/pdf" />
                            <div className="dropzone">
                                {Boolean(fileToUpload) ? (
                                    <>
                                        <UploadFile color="primary" />
                                        <p className="mt-05 mb-05">{fileToUpload?.name}</p>
                                        <p className="m-0">{fileToUpload ? parseFloat(fileToUpload?.size / 1024).toFixed(2) + 'KB' : ''}</p>
                                    </>
                                ) : (
                                    <>
                                        <CloudUpload color="primary" />
                                        <p>Drag and drop file , or click to select files</p>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                    <DialogActions className="p-0 pt-1">
                        <Button
                            onClick={() => {
                                if (uploadProcess !== 'uploading') {
                                    setOpenDialog(false);
                                    setFileToUpload(null);
                                    setUploadProcess('');
                                }
                            }}
                            disabled={uploadProcess === 'uploading'}
                            variant="contained"
                            color="secondary"
                        >
                            {uploadProcess === 'success' || uploadProcess === 'failed' ? 'Close' : 'Cancel'}
                        </Button>
                        {Boolean(fileToUpload && uploadProcess !== 'success' && uploadProcess !== 'failed') && (
                            <Button onClick={uploadFile} disabled={uploadProcess === 'uploading'} variant="contained">
                                {uploadProcess === 'uploading' ? 'Uploading...' : 'Upload'}
                            </Button>
                        )}
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog
                open={Boolean(actionsView)}
                onClose={() => {
                    setActionsView(false);
                }}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="lg"
                disableEscapeKeyDown
                PaperProps={{ style: { minWidth: '500px' } }}
            >
                <DialogContent>
                    <Typography fontSize={26} className="mb-1" fontWeight={'bold'}>
                        Complete Task: {selectedAction?.caseId}
                    </Typography>
                    <Formik initialValues={{ message: '', subject: '' }} enableReinitialize onSubmit={completeTask}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextInput multiline minRows={2} id="message" placeholder="Enter message" label="Message" required />
                                    </Grid>
                                </Grid>
                                <DialogActions className="p-0 pt-1">
                                    <Button
                                        onClick={() => {
                                            if (!isSubmitting) {
                                                setActionsView(false);
                                                setSelectedAction(null);
                                            }
                                        }}
                                        disabled={isSubmitting}
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Close
                                    </Button>
                                    <Button type="submit" disabled={isSubmitting} variant="contained">
                                        {isSubmitting ? <CircularProgress size={15} /> : 'Complete'}
                                    </Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>

            <Drawer anchor="right" open={openDrawer} PaperProps={{ style: { height: '100%', width: lg ? '50%' : md ? '75%' : '100%' } }}>
                <div className="d-flex flex-direction-column h-100 w-100">
                    <div className="d-flex bg-primary p-2 pl-1 align-items-center">
                        <div className="flex-1 f-14">{DrawerOptions[caseDrawer]}</div>
                        <Grid item xs={1} justifyContent="flex-end" container>
                            <IconButton
                                color="inherit"
                                onClick={() => {
                                    setOpenDrawer(false);
                                    // setCaseDetails(null);
                                    setCaseDrawer(0);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </Grid>
                    </div>
                    <div className="flex-1 d-flex flex-direction-column">
                        <CaseDetails caseDetails={caseDetails} setSelectionModel={setSelectionModel} selectionModel={selectionModel} showReportedInstitutions={showReportedInstitutions} />
                    </div>
                </div>
            </Drawer>

            <Dialog
                open={Boolean(caseAction)}
                onClose={() => {
                    setCaseAction(null);
                    setRecordsToEscalate([]);
                    // setSelectionModel([]);
                }}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="lg"
                disableEscapeKeyDown
            >
                <Formik initialValues={{ ...selectionModel }} enableReinitialize onSubmit={performAction}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent style={{ minWidth: '50vw' }}>
                                <Typography fontSize={24} fontWeight="bold">
                                    {caseAction == 'returnToFi' ? 'Return Cases to FI' : `${capitalize(caseAction || '')} Cases`}
                                </Typography>
                                <p className="mt-0">Kindly confirm selected case(s)</p>
                                {(caseAction === 'assign' || caseAction === 're-assign') && (
                                    <Grid item xs={4} className="mb-1">
                                        <SelectInput
                                            id="toUserId"
                                            label="Relationship Officer"
                                            required
                                            fullWidth
                                            field="id"
                                            fieldDisplay="name"
                                            options={relationshipOfficers.map((r) => ({
                                                ...r,
                                                name: `${r.lastName} ${r.firstName}`,
                                            }))}
                                        />
                                    </Grid>
                                )}
                                {(caseAction === 'resolve' || caseAction === 'escalate' || caseAction === 'de-escalate' || caseAction === 'assign' || caseAction === 're-assign') &&
                                    !escalateCaseFunction && (
                                        <>
                                            {/* <Grid item xs={4}  className='mt-05 mb-05'>
                                                <TextInput required id="subject" label="Subject" />
                                            </Grid> */}
                                            <Grid item xs={4} className="mt-1 mb-1">
                                                <TextInput multiline minRows={2} required id="message" label="Message" />
                                            </Grid>
                                        </>
                                    )}
                                {caseAction === 'de-escalate' && (
                                    <Grid item xs={4}>
                                        <SelectInput
                                            id="toUserId"
                                            label="Users"
                                            required
                                            fullWidth
                                            field="id"
                                            fieldDisplay="name"
                                            options={childRoleUsers.map((r) => ({
                                                ...r,
                                                name: `${r.lastName} ${r.firstName}`,
                                            }))}
                                        />
                                    </Grid>
                                )}
                                {caseAction === 'recategorise' && (
                                    <Grid item xs={4}>
                                        <SelectInput id="subcategoryCode" label="Sub-Category" required fullWidth field="code" fieldDisplay="name" options={subCategories} />
                                    </Grid>
                                )}
                                {caseAction === 'escalate' && !escalateCaseFunction && (
                                    <>
                                        <Grid item xs={4}>
                                            <SelectInput
                                                id="toUserId"
                                                label="Users"
                                                required
                                                fullWidth
                                                field="id"
                                                fieldDisplay="name"
                                                options={parentRoleUsers.map((r) => ({
                                                    ...r,
                                                    name: `${r.lastName} ${r.firstName}`,
                                                }))}
                                            />
                                        </Grid>
                                        {/* {
                                                recordsToEscalate.map((cs, index) => (
                                                    <Grid container key={index} alignItems='center' className='mt-05 mb-05' spacing={2}>
                                                        <Grid item xs={8}>
                                                            <TextInput readOnly value={cs.caseID} id="caseID" label="Case ID" />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <SelectInput customChange={(value) => handlePriorityChange(value, index)} id="priority" label="Priority" fullWidth field='code' fieldDisplay='label' value={cs.priority} options={[{ code: 'LOW', label: 'Low' }, { code: 'MEDIUM', label: 'Meduim' }, { code: 'HIGH', label: 'High' } ]} />
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            } */}
                                    </>
                                )}
                                <Divider className="mt-2" />
                                <Grid container alignItems="center" className="mt-05 mb-05" spacing={2}>
                                    {caseAction === 'escalate' && escalateCaseFunction
                                        ? recordsToEscalate.map((cs, index) => (
                                              <Grid container item xs={12} key={index} spacing={2}>
                                                  <Grid item xs={8}>
                                                      <TextInput readOnly value={cs.caseID} id="caseID" label="Case ID" />
                                                  </Grid>
                                                  <Grid item xs={4}>
                                                      <SelectInput
                                                          customChange={(value) => handlePriorityChange(value, index)}
                                                          id="priority"
                                                          label="Priority"
                                                          fullWidth
                                                          field="code"
                                                          fieldDisplay="label"
                                                          value={cs.priority}
                                                          options={[
                                                              {
                                                                  code: 'LOW',
                                                                  label: 'Low',
                                                              },
                                                              {
                                                                  code: 'MEDIUM',
                                                                  label: 'Medium',
                                                              },
                                                              {
                                                                  code: 'HIGH',
                                                                  label: 'High',
                                                              },
                                                          ]}
                                                      />
                                                  </Grid>
                                              </Grid>
                                          ))
                                        : selectionModel?.map((cs, index) => (
                                              <Grid item xs={12} key={index}>
                                                  <TextInput readOnly value={cs} id="caseID" label="Case ID" />
                                              </Grid>
                                          ))}
                                </Grid>
                            </DialogContent>
                            <DialogActions className="p-2  pb-1 pr-2">
                                <Button
                                    onClick={() => {
                                        setCaseAction(null);
                                        // setSelectionModel([]);
                                        setRecordsToEscalate([]);
                                    }}
                                    disabled={isSubmitting}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Cancel
                                </Button>

                                <Button type="submit" disabled={isSubmitting} variant="contained" color={getBtnColor()}>
                                    {isSubmitting ? <CircularProgress size={15} /> : capitalize(caseAction || '')}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

            <Dialog open={Boolean(messageModal)} TransitionComponent={Transition} keepMounted maxWidth="lg" disableEscapeKeyDown>
                <Formik initialValues={{ ...defMessage }} onSubmit={sendMessage}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <DialogContent style={{ minWidth: '50vw' }}>
                                {selectionModel?.map((cs, index) => (
                                    <Grid container key={index} alignItems="center" className="mt-05 mb-05" spacing={2}>
                                        <Grid item xs={12}>
                                            <TextInput readOnly value={cs} id="caseID" label="Case ID" />
                                        </Grid>
                                    </Grid>
                                ))}
                                <Divider className="mt-2 mb-0" />
                                <Grid container alignItems="center" className="mt-05 mb-05" spacing={2}>
                                    <Grid item xs={12}>
                                        <TextInput id="message" required label="Message" minRows={2} multiline />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DocumentInput id="attachment" label="Attachment" />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions className="p-2  pb-1 pr-2">
                                <Button onClick={() => setMessageModal(false)} disabled={isSubmitting} variant="contained" color="secondary">
                                    Cancel
                                </Button>

                                <Button type="submit" disabled={isSubmitting} variant="contained" color="primary">
                                    {isSubmitting ? <CircularProgress size={15} /> : 'Send'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ updatePageSize }, dispatch);
};

export default connect(({ user }) => ({ user }), mapDispatchToProps)(CaseTable);
